<template>
  <div>
    <v-card>
      <v-card-title v-if="GETTERS_INVITATION_ALL.type == 1" class="headline">Заявка на Приглашение на эксперимент
      </v-card-title>
      <v-card-title v-else class="headline">Заявка на справку о участии в эксперименте
      </v-card-title>

      <v-card-text v-if="editable.can_see">
        <v-row>
          <v-col cols="9">
            <v-card class="pa-4">
              <div>
                <v-row>
                  <v-col>
                      <p
                        class="subtitle-2 text-left"
                      >
                          <v-chip :color="status_descr(GETTERS_INVITATION_ALL.status, 'color')" text-color="white">
                            <v-avatar left>
                              <v-icon color="white">mdi-calendar-month</v-icon>
                            </v-avatar>
                                <b style="color:white;">от {{formate_date(GETTERS_INVITATION_ALL.created_at)}}</b>
                          </v-chip>
                      </p>
                  </v-col>
                  <v-col>
                    <p
                      class="subtitle-2 text-left"
                    >
                        <v-chip :color="status_descr(GETTERS_INVITATION_ALL.status, 'color')" text-color="white">
                              <b style="color:white;">{{status_descr(GETTERS_INVITATION_ALL.status, 'descr')}}</b>
                        </v-chip>
                    </p>
                  </v-col>
                  <v-col>
                    <p class="subtitle-2 text-left">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-google-circles</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >{{GETTERS_INVITATION_ALL.proposal.station}}</b>
                        </v-chip>
                    </p>
                  </v-col>
                  <v-col>
                    <p class="subtitle-2 text-left">
                        <v-chip color="#c22dff" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-alpha-p-box</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >#{{GETTERS_INVITATION_ALL.proposal.id}}</b>
                        </v-chip>
                    </p>
                  </v-col>
                </v-row>

                <v-divider v-if="GETTERS_INVITATION_ALL.file_id > 0 || GETTERS_INVITATION_ALL.status == 2"></v-divider>
                  <v-row v-if="GETTERS_INVITATION_ALL.status == 2 && !GETTERS_INVITATION_ALL.file_id">
                    <v-col>
                      <v-file-input
                        v-model="new_file"
                        label="Добавить файл"
                        color="#15336d"
                        :success="loadedFile"
                        :loading="loadedFile"
                        prepend-icon="mdi-paperclip">
                      </v-file-input>
                    </v-col>                    
                  </v-row>

                  <v-row v-if="GETTERS_INVITATION_ALL.file_id > 0">
                    <v-col>

                      <v-card width="100%" style="margin:10px;">
                        <v-list subheader>
                          <v-list-item>
                            <v-list-item-avatar  @click="openFile(GETTERS_INVITATION_ALL.file.name)" >
                              <v-icon left>mdi-file</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title @click="openFile(GETTERS_INVITATION_ALL.file.name)" >
                                <v-badge color="red lighten-2" :content="GETTERS_INVITATION_ALL.file.type==7 ? 'Приглашение' : 'Справка'" x-small inline>
                                  <p style="margin-bottom: 0px;">{{ GETTERS_INVITATION_ALL.file.name.split('/').reverse()[0] }}</p>
                                </v-badge>
                              </v-list-item-title>
                              <v-list-item-subtitle v-text="g.toDate(GETTERS_INVITATION_ALL.file.add_date)"/>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn @click="openFile(GETTERS_INVITATION_ALL.file.name)" icon>
                                <v-icon color="grey lighten-1">mdi-download</v-icon>
                              </v-btn>
                              <v-btn @click="deleteFile()" icon>
                                <v-icon color="grey lighten-1">mdi-delete</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>                    
                  </v-row>

                <v-divider></v-divider>

                <v-row>
                  <v-col cols="3">
                    <v-card-text>
                      <p> Инициатор: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9">
                    <p class="subtitle-2 text-left pt-4">
                      <v-badge color="red lighten-2" :content="GETTERS_INVITATION_ALL.creator.individual.phone_number" x-small overlap>
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-account</v-icon>
                          </v-avatar>
                          <b
                            style="color:white;"
                          >{{ GETTERS_INVITATION_ALL.creator.individual.last_name }} {{ GETTERS_INVITATION_ALL.creator.individual.first_name }} {{ GETTERS_INVITATION_ALL.creator.individual.middle_name }}</b>
                        </v-chip>
                      </v-badge>
                    </p>

                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row style="padding-right: 80px;">
                  <v-col cols="3">
                    <v-card-text>
                      <p> Комментарий инициатора: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9" style="display: flex; align-items: center;">
                    <p v-if="GETTERS_INVITATION_ALL.user_comment"> {{ GETTERS_INVITATION_ALL.user_comment }}</p>
                    <p v-else> - не указано</p>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row style="padding-right: 80px;" v-if="GETTERS_INVITATION_ALL.status == 3 || GETTERS_INVITATION_ALL.status == 4">
                  <v-col cols="3">
                    <v-card-text>
                      <p> Комментарий администратора: </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="9" style="display: flex; align-items: center;">
                    <p v-if="GETTERS_INVITATION_ALL.admin_comment"> {{ GETTERS_INVITATION_ALL.admin_comment }}</p>
                    <p v-else> - не указано</p>
                  </v-col>
                </v-row>
              </div>
            </v-card>

          </v-col>
          <v-col cols="3">
            <v-card class="pa-2">
              <v-row v-if="GETTERS_INVITATION_ALL.status == 3 && GETTERS_INVITATION_ALL.admin_text">
                <p
                    class="subtitle-2 text-left pl-2"
                  >
                    {{ GETTERS_INVITATION_ALL.admin_text }}
                </p>
              </v-row>

              <template v-if="editable.can_print_pdf">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_invitation('proposal')"
                      outlined
                      width="100%"
                    >proposal в .PDF</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>

              <template v-if="editable.can_export">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="print_invitation('draft')"
                      outlined
                      width="100%"
                    >Шаблон .DOC</v-btn>
                    </div>
                  </template>
                </v-list-item>
                <!-- <v-spacer style="height:10px;"></v-spacer> -->
              </template>


              <v-divider class="mt-4"></v-divider>

              <template v-if="editable.buttons.in_work">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 2, invitation_status_change_dialog = true, change_dialog_text = ''"
                      outlined
                      width="100%"
                    >Взять в работу</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>
              <template v-if="editable.buttons.reject">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 4, invitation_status_change_dialog = true, change_dialog_text = ''"
                      outlined
                      width="100%"
                    >отклонить</v-btn>
                    </div>
                  </template>
                </v-list-item>
              </template>
              <template  v-if="editable.buttons.done">
                <v-spacer style="height:10px;"></v-spacer>
                <v-list-item>
                  <template>
                    <div class="d-flex flex-column align-start" style="width: 100%;">
                      <v-btn
                      @click="new_status = 3, invitation_status_change_dialog = true, change_dialog_text = ''"
                      outlined
                      width="100%"
                    >Оформлен</v-btn>
                    </div>
                    <v-spacer style="height:10px;"></v-spacer>
                  </template>
                </v-list-item>
              </template>

              <v-divider class="mt-4"></v-divider>

              <p class="mb-0 mt-2 ml-4">История действий:</p>
              <template v-for="hist in history">
                <v-card v-if="hist.is_active" class="ma-2 pt-2 pl-2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-card-title 
                        v-bind="attrs"
                        v-on="on"
                        class="pa-0"> {{  hist.action.descr }}</v-card-title>
                    </template>
                    <span>{{ hist.action.descr_full }}</span>
                  </v-tooltip>
                  <v-card-text class="pa-0"> {{  hist.creator.individual.first_name }} {{  hist.creator.individual.last_name }}</v-card-text>
                  <v-card-text class="pa-0"> {{  hist.created_at.substr(0,16) }}</v-card-text>
                  <v-card-text class="pa-0" v-if="hist.comment"> {{  hist.comment }}</v-card-text>
                </v-card>
              </template>

            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>


    <v-dialog v-model="invitation_status_change_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Изменить статус заявки
        </v-card-title>
        <v-card-text >Вы уверены?</v-card-text>
        <v-card-text v-if="new_status==3 && !GETTERS_INVITATION_ALL.file_id" style="color: #da0000;">Подгрузите скан запрошенного файла. Без него закрыть запрос невозможно</v-card-text>
        <v-card-text v-if="new_status==4">Пожалуйста, опишите подробно причину. Этот ответ увидит заявитель:</v-card-text>

        <v-card-text v-if="new_status==3 || new_status==4">
          <v-textarea
            v-model="change_dialog_text"
            outlined
            placeholder="Комментарий"
            type="number"
            counter="300"
            maxLength="300"
            rows="2"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="invitation_status_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            :disabled="new_status==3 && !GETTERS_INVITATION_ALL.file_id"
            @click="change_invitation_status()">Подтвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import { DOMEN } from '../../../../vars.js'

export default {
  beforeMount (){
    this.load_available_actions()
  },

  mounted() {
  },

  name: 'invitationModalCard',

  props: {
    from_proposal: Boolean,
  },

  data: () => ({
    new_status: 0,
    invitation_status_change_dialog: false,
    change_dialog_text: '',

    editable: {
      can_see: false,
      can_edit : false,
      can_export : false,
      buttons : {
        reject : false,
        done : false,
        in_work : false,
      }
    },
    proposalDialogCard: false,
    history: [],

    loadedFile: false,
    new_file: null,

  }),

  watch: {
    GETTERS_INVITATION_ALL(val) {
      this.load_available_actions()
    },

    new_file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val)
      }
    },

  },

  computed: {
    ...mapGetters([
      'GETTERS_INVITATION_ALL',
    ]),
  },

  methods: {
    ...mapActions([
      'INVITATION_MAKE_ACTION',
      'GET_INVITATION_AVAILABLE_ACTIONS',
      'GET_ACTIONS_HISTORY',
      'FILE_SEND',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    load_available_actions(){
      this.editable = {
          can_see: false,
          can_edit : false,
          can_export : false,
          buttons : {
            reject : false,
            done : false,
            in_work : false,
          }
        },

      this.GET_INVITATION_AVAILABLE_ACTIONS(this.GETTERS_INVITATION_ALL.id).then(res => {
        this.editable = res
        this.load_history()
      })
    },

    openFile(fileName) {
      window.open(DOMEN + `/media/${fileName}`, '_blank')
    },

    validateFile(val) {
      const type = val.name.split('.').pop();

      if (type === 'pdf' || type === 'jpg' || type === 'png') {
        if (val.size <= 6291456) {
            this.checkFile =  true
            this.saveFile()
        } else {
          this.$messageHelper(this.$t('Step2.6md'), 'error')
          this.checkFile = false
          this.new_file = ''

        }
      } else {
        this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        this.checkFile = false
        this.new_file = ''
      }
    },
    
    saveFile() {
      this.loadedFile = true
      const files = new FormData();
      files.append('file', this.new_file);
      files.append('proposal_id', this.GETTERS_INVITATION_ALL.proposal_id)
      files.append('type', this.GETTERS_INVITATION_ALL.type == 1 ? 7 : 8) 

      this.FILE_SEND(files)
        .then((res) => {
          this.save_file_id(res.data.id)
          this.new_file = null
          this.loadedFile = false
        })
        .catch(() => this.loadedFile = false)
    },

    save_file_id(file_id){
      this.UPDATE_OVERLAY(true)
      var data = {
        invitation_id: this.GETTERS_INVITATION_ALL.id, 
        action: 'add_file',
        file_id: file_id,
      }
      this.INVITATION_MAKE_ACTION(data)
      .then(res => {
        if(res.status){
          this.$messageHelper(`файл подгружен`, 'success', 5000)
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.UPDATE_OVERLAY(false)
        }
        else{
          this.UPDATE_OVERLAY(false)
          if(res.error !== undefined){
            this.$messageHelper(res.error, 'error', 5000)
          }
          else
            this.$messageHelper(`что-то пошло не так... попробуйте заново`, 'error', 5000)
        }
      })
    },

    deleteFile(){
      this.UPDATE_OVERLAY(true)
      var data = {
        invitation_id: this.GETTERS_INVITATION_ALL.id, 
        action: 'delete_file',
      }
      this.INVITATION_MAKE_ACTION(data)
      .then(res => {
        if(res.status){
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.UPDATE_OVERLAY(false)
        }
        else{
          this.UPDATE_OVERLAY(false)
          if(res.error !== undefined){
            this.$messageHelper(res.error, 'error', 5000)
          }
          else
            this.$messageHelper(`что-то пошло не так... попробуйте заново`, 'error', 5000)
        }
      })
    },

    load_history(){
      var data = {
        object_type: 4,
        object_id: this.GETTERS_INVITATION_ALL.id
      }

      this.GET_ACTIONS_HISTORY(data).then(res => {
        this.history = res.history
      })
    },

    change_invitation_status(){
      this.UPDATE_OVERLAY(true)

      this.INVITATION_MAKE_ACTION({
        invitation_id: this.GETTERS_INVITATION_ALL.id, 
        action: 'next_status',
        new_status_id: this.new_status,
        admin_comment: this.change_dialog_text,
      })
        .then(res => {
          this.invitation_status_change_dialog = false
          if(res.status){
            this.$messageHelper(`Статус пропуска успешно изменен`, 'success', 5000)
            this.$emit('updateParent', {item: -1, close_modal: false})
            this.UPDATE_OVERLAY(false)
          }
          else{
            this.UPDATE_OVERLAY(false)
            if(res.error !== undefined){
              this.$messageHelper(res.error, 'error', 5000)
            }
            else
              this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
        });

    },
    
      
    print_invitation(type){
      this.UPDATE_OVERLAY(true)
      var data = {
        invitation_id: this.GETTERS_INVITATION_ALL.id, 
        type: type,
        action: 'print'
      }
      this.INVITATION_MAKE_ACTION(data)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          if(res.url != undefined){
            window.open(`${DOMEN}${res.url}`, '_blank');
          }
          else
            this.$messageHelper('error', 'error', 3000);
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
        });
    },

    status_descr(status, type){
      if(type == 'descr'){
        if (status == 1)
          return 'Новый запрос'
        else if (status == 2)
          return 'Оформляется'
        else if (status == 3)
          return 'Готов'
        else if (status == 4)
          return 'Отменен'
        else
          return 'Не определен'
      }
      else{
        if (status == 1)
          return '#a9a9a9'
        else if (status == 2)
          return '#ada509'
        else if (status == 3)
          return '#1b8e30'
        else if (status == 4)
          return 'red lighten-2'
      }
    },

    formate_date(date_time){
      var date_obj = new Date(date_time)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear()
    },
  }

};
</script>
